import { render, staticRenderFns } from "./UBIService.vue?vue&type=template&id=1ffdd72f&scoped=true"
import script from "./UBIService.vue?vue&type=script&lang=js"
export * from "./UBIService.vue?vue&type=script&lang=js"
import style0 from "./UBIService.vue?vue&type=style&index=0&id=1ffdd72f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffdd72f",
  null
  
)

export default component.exports